import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const sanityProjectId = process.env.REACT_APP_SANITY_PROJECT_ID;

if (!sanityProjectId) {
  console.error("Sanity Project ID is not set. Please set REACT_APP_SANITY_PROJECT_ID.");
  // Application might not function correctly without a Project ID.
}

export const client = sanityClient({
  projectId: sanityProjectId, // Use the environment variable
  dataset: 'production', // Usually 'production', can remain hardcoded or also be an env var if needed
  apiVersion: '2023-05-03', // Use a recent API version
  useCdn: true, // `false` if you want to ensure fresh data
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source); 